import { z } from 'zod';
export const FlowExportToSftpResponseSchema = z.object({
    gsPath: z.string(),
    gcsFileSizeBytes: z.number().optional(),
    resolvedSftpHost: z.string(),
    resolvedSftpPath: z.string(),
});
//# sourceMappingURL=response.js.map